import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';

import { Row, Col, Image, Button } from "react-bootstrap";

import Truncate from "react-truncate";

import { deselectAsset, invalidateCollectionSelection } from 'actions/selection';
import styles from './components.module.scss';

const defaultAssetIcon = "images/default_asset.jpg";

export default function ContentSelection(props) {
  const [viewMore, setViewMore] = useState(false);

  const assets = useSelector(state => _.get(state, `application.assets`, []));
  const collection = useSelector(state => _.get(state, `application.collection`, null));

  const empty = collection == null && assets.length == 0;

  return (
    <div className={styles.contentSelection}>
      {empty &&
        <div className={styles.empty}>

          <p>No assets added yet. you can add them from your collections, or streams. </p>
        </div>
      }

      {collection &&
        <CollectionView collection={collection} />
      }

      <AssetsGrid assets={assets} />
    </div>)
}

function CollectionView({ collection }) {
  const dispatch = useDispatch();

  const onRemove = () => {
    dispatch(invalidateCollectionSelection());
  }

  let assetCount = collection.assetsCount;
  let sectionsCount = collection.sectionsCount;

  let metadata = `${assetCount} Asset${assetCount > 1 ? 's' : ''}`;

  if (sectionsCount > 0) {
    metadata = `${sectionsCount} Section${sectionsCount > 1 ? 's' : ''}`;
  }

  let collectionIcon =  _.get(collection.banner, 'background.thumbnail', defaultAssetIcon);

  if(!collectionIcon){
    collectionIcon = defaultAssetIcon;
  }

  return (
    <div className={styles.collectionContainer}>
      <div className={styles.collection}>
        <div className={styles.icon}>
          <div className={styles.folder}>
            <Image src={collectionIcon} />
          </div>
        </div>

        <div className={styles.details}>
          <div className={styles.name}>
            <Truncate lines={1}>{collection.name}</Truncate>
          </div>
          <div className={styles.metadata}>{metadata}</div>
        </div>

        <Button variant="link" className={cx("paperflite-close", styles.remove)} onClick={onRemove}></Button>
      </div>
    </div>
  );
}

function AssetsGrid({ assets }) {
  const [viewMore, setViewMore] = useState(false);
  const [items, setItems] = useState(assets);
  const maxCount = 4;
  const empty = assets == null || assets.length === 0;
  const remaining = assets.length - maxCount;

  useEffect(() => {
    var result = assets;
    if (!viewMore) {
      result = [...assets].slice(0, maxCount);
    }
    setItems(result);
  }, [assets, viewMore]);

  if (empty) {
    return false;
  }

  return (
    <div className={styles.assetGrid}>
      <div className={styles.assets}>
        {items.map(asset => {
          return <AssetView key={asset.id} asset={asset} />
        })}
      </div>
      {remaining > 0 &&
        <button className={styles.viewMore} onClick={() => {
          setViewMore(!viewMore)
        }}>
          {viewMore ? 'show less' : <>view more ({remaining}) <i className='paperflite-dropdown'/></>}
        </button>
      }
    </div>
  );
}

function AssetView({ asset }) {
  const dispatch = useDispatch();

  const onRemove = () => {
    dispatch(deselectAsset(asset));
  }

  return (
    <div className={styles.asset}>
      <div className={styles.icon}>
        <Image src={(asset.icon && asset.icon.thumbnail) || defaultAssetIcon} />
        <div className={styles.delete} onClick={onRemove}>
          <span className="paperflite-close"></span>
        </div>
      </div>
      <div className={styles.name}>
        <Truncate lines={1}>{asset.name}</Truncate>
      </div>
    </div>
  );
}